import type { Activity } from '../types/activity';

export interface ActivityRow extends Activity {
  displayIndex: string;
  subRows?: ActivityRow[];
}

export function buildActivityTree(items: Activity[]): ActivityRow[] {
  const visibleIds = new Set(items.map((item) => item.id));
  const children = new Map<string | null, Activity[]>();
  items.forEach((item) => {
    const parentId = item.parentId && visibleIds.has(item.parentId) ? item.parentId : null;
    children.set(parentId, [...(children.get(parentId) || []), item]);
  });
  const visit = (parentId: string | null, prefix = ''): ActivityRow[] =>
    (children.get(parentId) || [])
      .sort((left, right) => (left.sortOrder || 0) - (right.sortOrder || 0))
      .map((item, index) => {
        const displayIndex = prefix ? `${prefix}.${index + 1}` : `${index + 1}`;
        const subRows = visit(item.id, displayIndex);
        return { ...item, displayIndex, subRows: subRows.length ? subRows : undefined };
      });
  return visit(null);
}

export function flattenActivityRows(rows: ActivityRow[]): ActivityRow[] {
  return rows.flatMap((row) => [row, ...flattenActivityRows(row.subRows || [])]);
}
